import adapter from './adapter'
import { collectionMutations } from '@/store/collection'

const { upsertMany, upsertOne, removeOne } = collectionMutations(adapter)

export default {
  upsertMany,
  upsertOne,
  removeOne,
}
